module.exports = __webpack_public_path__ + "img/logo.27e21a68.png";